export default __webpack_public_path__ + "static/media/Logo-svg.3f564480.png";